import { Dispatch, SetStateAction } from 'react';

import {
  AuthenticatePartnerCloudUserRequestModel,
  AuthenticatePartnerCloudUserResultModel,
  EmptyApiResponse,
  PartnerCloudDataStreamingDeviceModel,
  PartnerCloudDataStreamingInfoModel,
  PartnerCloudDeviceModel,
  PostPartnerCloudDataStreamingDevicesRequestModel,
  WebhookChangeModel,
  WebhookModel,
} from '@resideo/web-integration-services-api-client';

type DeepRequired<T> = {
  [P in keyof T]-?: NonNullable<T[P]>;
};

export type AccountType = 'pro' | 'distributor' | 'developer' | 'personal';

export type PartnerCloudAccount =
  DeepRequired<PartnerCloudDataStreamingInfoModel>;

export type PartnerCloudDevice = DeepRequired<PartnerCloudDeviceModel>;

export type PartnerCloudConnectedDevice =
  DeepRequired<PartnerCloudDataStreamingDeviceModel>;

export type PartnerCloudUserAuthPayload =
  AuthenticatePartnerCloudUserRequestModel;

export type PartnerCloudUserAuthRequest = {
  partnerCloudId: string;
  requestBody: PartnerCloudUserAuthPayload;
};

export type PartnerCloudUserAuthResponse =
  DeepRequired<AuthenticatePartnerCloudUserResultModel>;

export type PartnerCloudDeviceConnectPayload =
  DeepRequired<PostPartnerCloudDataStreamingDevicesRequestModel>;

export type PartnerCloudDeviceConnectRequest = {
  partnerCloudId: string;
  requestBody: PartnerCloudDeviceConnectPayload;
};

export type PartnerCloudDeviceConnectResponse = EmptyApiResponse;

export type PartnerCloudDeviceRemoveRequest = {
  partnerCloudId: string;
  deviceId: string;
};

export type PartnerCloudDeviceRemoveResponse = void;

export type PartnerCloudDisconnectRequest = {
  partnerCloudId: string;
  devices: PartnerCloudConnectedDevice[];
};

export type PartnerCloudOAuthRequest = {
  code: string;
  codeVerifier: string;
  partnerCloudId: string;
};

export type UserWebhook = DeepRequired<WebhookModel>;

export type UserWebhooks = UserWebhook[];

export type UsersCreateWebhookRequest = DeepRequired<WebhookChangeModel>;

export enum Steps {
  OAUTH_SIGN_IN,
  SIGN_IN,
  TERMS_ACCEPTANCE,
  DEVICE_SELECTION,
}

export interface ModalProps {
  account: PartnerCloudAccount;

  oAuthData?: PartnerCloudOAuthRequest;

  closeModal: () => void;
}

export interface StepComponentProps extends ModalProps {
  userSession: PartnerCloudUserAuthResponse | undefined;
  setUserSession: Dispatch<
    SetStateAction<PartnerCloudUserAuthResponse | undefined>
  >;

  setStep: Dispatch<SetStateAction<Steps>>;
}

export interface DeviceInfo {
  id: string;
  productName: string;
  deviceName: string;
  isOwner: boolean;
}

export interface UserDevicesData {
  [locationName: string]: DeviceInfo[];
}

export interface RisError {
  name: string;
  url: string;
  status: number;
  statusText: string;
  body: { errors: { message: string; code: string }[] };
}

export interface DownloadRequest {
  id: string;
  name: string;
  size: number;
  created_at: number;
  isFullDataRequest: boolean;
}

export type DownloadRequestsData = DownloadRequest[];
